/* BergHeat — Countdown der Ankuendigungsleiste (sections/banner.liquid).

   Zwei Quellen fuer die Frist:

   data-wb-session  Sitzungs-Countdown. Jede Browser-Sitzung bekommt eine
                    zufaellige Laufzeit zwischen data-wb-min und data-wb-max
                    (Sekunden). Ende und Laufzeit stehen im Sitzungs-Cookie
                    bh_deal (ohne Ablaufdatum, gilt fuer alle Tabs, weg mit dem
                    Schliessen des Browsers). Bei 0 startet derselbe Countdown
                    von vorn. Ausdrueckliche Anweisung des Betreibers vom
                    08.10.2026. Ohne Cookies laeuft er nur im Speicher der Seite.

   data-wb-deadline festes Enddatum aus dem Setting "deadline" (mit
                    Zeitzonen-Offset des Shops). Fehlt es oder ist es vorbei,
                    blendet sich die Leiste aus. */
(function () {
  var COOKIE = 'bh_deal';
  var memory = null;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function readSession() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)bh_deal=(\d+)\.(\d+)/);
      if (m) return { end: +m[1], total: +m[2] };
    } catch (e) {}
    return memory;
  }

  function writeSession(s) {
    memory = s;
    try { document.cookie = COOKIE + '=' + s.end + '.' + s.total + '; path=/; SameSite=Lax'; } catch (e) {}
  }

  function sessionOf(root) {
    var now = Date.now();
    var s = readSession();
    if (!s || !s.total) {
      var min = parseInt(root.getAttribute('data-wb-min'), 10) || 3600;
      var max = parseInt(root.getAttribute('data-wb-max'), 10) || min;
      if (max < min) max = min;
      var total = min + Math.floor(Math.random() * (max - min + 1));
      s = { end: now + total * 1000, total: total };
      writeSession(s);
    } else if (s.end <= now) {
      s = { end: now + s.total * 1000, total: s.total };
      writeSession(s);
    }
    return s;
  }

  function deadlineOf(root) {
    var raw = root.getAttribute('data-wb-deadline');
    if (!raw) return null;
    var t = new Date(raw).getTime();
    return isNaN(t) ? null : t;
  }

  function tickAll() {
    var bars = document.querySelectorAll('[data-wb-bar][data-wb-countdown]');
    for (var i = 0; i < bars.length; i++) {
      var root = bars[i];
      var end, total = 0;

      if (root.hasAttribute('data-wb-session')) {
        var s = sessionOf(root);
        end = s.end;
        total = s.total;
      } else {
        end = deadlineOf(root);
        if (end === null || end <= Date.now()) {
          root.style.display = 'none';
          continue;
        }
      }

      var hEl = root.querySelector('[data-h]');
      var mEl = root.querySelector('[data-m]');
      var sEl = root.querySelector('[data-s]');
      if (!hEl || !mEl || !sEl) continue;

      var diff = Math.max(0, Math.ceil((end - Date.now()) / 1000));
      hEl.textContent = pad(Math.floor(diff / 3600));
      mEl.textContent = pad(Math.floor((diff % 3600) / 60));
      sEl.textContent = pad(diff % 60);

      var prog = root.querySelector('[data-wb-prog]');
      if (prog && total) prog.style.transform = 'scaleX(' + Math.min(1, diff / total).toFixed(4) + ')';
    }
  }

  /* Die Leiste steht im Quelltext vor der Kopfzeile und wird nach oben in den
     Header gehaengt — das gilt fuer alle Modi, auch fuer die Hinweisleiste
     ohne Countdown. */
  function moveIntoHeader() {
    var bar = document.querySelector('[data-wb-bar]');
    var header = document.getElementById('header-component');
    if (!bar || !header) return false;
    if (bar.dataset.wbMoved) return true;
    header.insertBefore(bar, header.firstChild);
    bar.dataset.wbMoved = '1';
    return true;
  }

  function start() {
    tickAll();
    if (document.querySelector('[data-wb-bar][data-wb-countdown]')) {
      setInterval(tickAll, 1000);
      window.addEventListener('pageshow', tickAll);
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) tickAll();
      });
    }
    if (!moveIntoHeader()) {
      var tries = 0;
      var t = setInterval(function () {
        if (moveIntoHeader() || ++tries > 40) clearInterval(t);
      }, 150);
    }
  }

  /* Die Zahlen sofort setzen (das Skript steht direkt hinter der Leiste),
     damit beim Laden nicht kurz 00:00:00 steht. */
  tickAll();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
